module.exports = __webpack_public_path__ + "img/CV.986e1c6a.png";